var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useEffect, useCallback } from "react";
import { createPortal } from "preact/compat";
import s from "./Modal.module.css";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, } from "body-scroll-lock";
import { Cross } from "@components/icons";
import cn from "classnames";
var Modal = function (_a) {
    var className = _a.className, children = _a.children, open = _a.open, onClose = _a.onClose, _b = _a.onEnter, onEnter = _b === void 0 ? null : _b;
    var ref = useRef();
    var modalClassName = cn(s.modal, className);
    var handleKey = useCallback(function (e) {
        if (e.key === "Escape") {
            return onClose();
        }
    }, [onClose]);
    useEffect(function () {
        if (ref.current) {
            if (open) {
                disableBodyScroll(ref.current);
                window.addEventListener("keydown", handleKey);
            }
            else {
                enableBodyScroll(ref.current);
            }
        }
        return function () {
            window.removeEventListener("keydown", handleKey);
            clearAllBodyScrollLocks();
        };
    }, [open, handleKey]);
    if (open) {
        return createPortal(_jsx("div", __assign({ className: s.root }, { children: _jsxs("div", __assign({ className: modalClassName, role: "dialog", ref: ref }, { children: [_jsx("button", __assign({ onClick: function () { return onClose(); }, "aria-label": "Close panel", className: "transition ease-in-out duration-150 focus:outline-none absolute bg-primary sm:border sm:-right-4 right-2 sm:-top-4 -top-9 z-10 p-1 rounded-full" }, { children: _jsx(Cross, {}, void 0) }), void 0), children] }), void 0) }), void 0), document.body);
    }
    return _jsx(_Fragment, {}, void 0);
};
export default Modal;
